<!-- @format -->

<div class="hmf-grid hmf-mt-xs hmf-mx-0 top-padding">
	<div class="hmf-col hmf-span-12 hmf-px-s-0 hmf-text-align-center">
		<img
			src="assets/image/no_state_favorites.svg"
			class="reactionLoveFilledIcon"
			alt="empty favorites Icon" />

		<div>
			<p class="hmf-header-bold-l hmf-mt-m">
				{{
					showBtsDashUpdates
						? 'Ready to Gear Up Your List?'
						: 'Sign in to Save & View Your Lists'
				}}
			</p>
			<p class="margin-bottom hmf-subheader-m">
				{{
					showBtsDashUpdates
						? 'Sign in to save to your list and view if on DICK’s.com or the DICK’s app!'
						: 'We made your Lists accessible from our websites and app, allowing you
to be connected and synced with your favorite products wherever you are!'
				}}
			</p>
			<p class="margin-bottom hmf-subheader-m">
				{{
					showBtsDashUpdates
						? 'Signing in helps you sync your favorite styles & gear across devices.'
						: 'Sign in to save, view, and sync your favorite gear across devices.'
				}}
			</p>
		</div>
	</div>
	<div
		class="hmf-mt-m hmf-col hmf-span-12 hmf-span-l-8 hmf-offset-l-2 hmf-display-flex hmf-flex-wrap hmf-justify-content-center"
		[ngClass]="{
			'hmf-mb-m': !showBtsDashUpdates,
			'hmf-mb-0': showBtsDashUpdates
		}">
		<hmf-button
			class="hmf-col hmf-span-12 hmf-span-m-4 hmf-mr-0 hmf-mb-m hmf-mb-m-0 hmf-mr-m-m"
			[variant]="'primary'"
			[text]="'SIGN IN'"
			(click)="signIn()">
		</hmf-button>
		<hmf-button
			class="hmf-col hmf-span-12 hmf-span-m-4 hmf-ml-0 hmf-mr-m-m"
			[variant]="'secondary'"
			[text]="'CREATE ACCOUNT'"
			(click)="createAccount()">
		</hmf-button>
	</div>
	@if (showBtsDashUpdates) {
		<div
			class="hmf-mt-m hmf-col hmf-span-12 hmf-display-flex hmf-justify-content-center hmf-m-0 hmf-mb-m-m">
			<p class="hmf-legal-xs hmf-m-0 signed-out-scorecard-legal hmf-text-align-center">
				For additional details, please see the
				<a
					href="https://www.dickssportinggoods.com/s/scorecard-benefits"
					target="_blank"
					>Scorecard Terms and Conditions</a
				>.
			</p>
		</div>
	}
</div>

@if (showBtsDashUpdates) {
	<hmf-divider
		class="hmf-mx-m-xxxl"
		[my]="'s'"
		[mx]="'xxs'"></hmf-divider>

	<div class="hmf-display-flex hmf-justify-content-m-center hmf-flex-column hmf-flex-m-row">
		<div class="hmf-m-auto hmf-m-m-s hmf-mt-xs hmf-mb-xxs">
			<img
				[src]="imgUrlPartial + '/heart_list_login.png'"
				class="hmf-mt-l hmf-w-100 signed-out-image"
				alt="Add Items to Your Lists"
				loading="lazy" />
			<div
				class="hmf-mt-m"
				style="max-width: 280px">
				<h3>Add Gear You Love</h3>
				<p>
					Keep track of what you need and where to find it create lists and use the heart
					icon to favorite your finds
				</p>
			</div>
		</div>
		<div class="hmf-m-auto hmf-m-m-s hmf-mt-xs hmf-mb-xxs">
			<img
				[src]="imgUrlPartial + '/storemode_list_login.png'"
				class="hmf-mt-l hmf-w-100 signed-out-image"
				alt="Turn on Store Mode"
				loading="lazy" />
			<div
				class="hmf-mt-m"
				style="max-width: 280px">
				<h3>Activate Store Mode</h3>
				<p>Use the app to open your list, scan barcodes, and add items in store</p>
			</div>
		</div>
		<div class="hmf-m-auto hmf-m-m-s hmf-mt-xs hmf-mb-xxs">
			<img
				[src]="imgUrlPartial + '/share_list_login.png'"
				class="hmf-mt-l hmf-w-100 signed-out-image"
				alt="Share Your Lists"
				loading="lazy" />
			<div
				class="hmf-mt-m"
				style="max-width: 280px">
				<h3>Share</h3>
				<p>
					Share your curated lists and favorite items with friends, family, or teammates
					easily
				</p>
			</div>
		</div>
	</div>
}

<div>
	<my-account-templates-shop-by-category></my-account-templates-shop-by-category>
</div>
